
export default {
  state: {
    program: null,
    client: null
  },

  mutations:
  {
    setProgram: (state, program) => {
      state.program = program
    },
    setClient: (state, client) => {
      state.client = client
    }
  },

  actions:
  {
  }
}
